import { Switch } from 'antd';
import styled from 'styled-components';

export default styled(Switch)`
	// Add your styles here
`;
